var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoParentalRating6 = function SvgIcoParentalRating6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC0",
    d: "M12 24c6.628 0 12-5.372 12-12S18.628 0 12 0 0 5.372 0 12s5.372 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.042 4.794a7.205 7.205 0 0 1 7.196 7.196c0 3.969-3.228 7.197-7.196 7.197-3.969 0-7.198-3.228-7.198-7.197s3.229-7.196 7.198-7.196m0-2.4a9.595 9.595 0 0 0-9.597 9.596c0 5.3 4.296 9.595 9.597 9.595 5.299 0 9.595-4.295 9.595-9.595s-4.296-9.595-9.595-9.595"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.803 9.732c1.182-1.468 1.438-1.664 1.822-1.664.531 0 .768.501.768.768 0 .522-.768.936-1.486 1.99l.02.018c.147-.048.323-.078.62-.078 1.16 0 1.97 1.093 1.97 2.196 0 1.368-1.045 2.432-2.552 2.432-1.556 0-2.55-.975-2.55-2.393 0-1.27.7-2.411 1.388-3.269m1.162 4.127a.906.906 0 0 0 .896-.897.906.906 0 0 0-.896-.897.906.906 0 0 0-.896.897c0 .483.404.896.896.896"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcoParentalRating6;